export default "__VITE_ASSET__DLpTdn8M__"